import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class CodeBLTypeListItem extends SearchModelBase {
    mblType: string = '';
    cid: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'Master B/L Type', width: 300, dataIndex: 'mblType'})
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: CodeBLTypeListItem.prototype.mblType, orderByAscending: false };

    public static formatData(data: CodeBLTypeListItem[]) {
        return data.map((d: CodeBLTypeListItem) => ({
          ...d,
        }));
    }

}
